import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';

import GradientButton from 'src/components/elements/GradientButton';
import { TextField } from 'src/components/elements/TextField';

import { ReportsFormValues, reportsFormSchema } from './ReportdForm.scheme';

import { useSolarLandingSubmissionsMutation } from '../../api';

import styles from './ReportsForm.scss';

export const ReportsForm = () => {
  const { control, handleSubmit, reset } = useForm<ReportsFormValues>({
    resolver: yupResolver(reportsFormSchema),
    mode: 'onTouched',
  });

  const resetFormFields = useCallback(() => {
    reset({
      firstName: '',
      lastName: '',
      companyName: '',
      email: '',
    });
  }, [reset]);

  const solarLandingSubmissionsMutation = useSolarLandingSubmissionsMutation({
    onSuccess: resetFormFields,
  });

  const onSubmitHandler = (data: ReportsFormValues) => {
    solarLandingSubmissionsMutation.mutate(data);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmitHandler)}
      aria-label="Reports form"
      className={styles.form}
    >
      <TextField<ReportsFormValues>
        disabled={solarLandingSubmissionsMutation.isLoading}
        control={control}
        name="firstName"
        placeholder="First name"
      />
      <TextField<ReportsFormValues>
        disabled={solarLandingSubmissionsMutation.isLoading}
        control={control}
        name="lastName"
        placeholder="Last name"
      />
      <TextField<ReportsFormValues>
        disabled={solarLandingSubmissionsMutation.isLoading}
        control={control}
        name="companyName"
        placeholder="Company name"
      />
      <TextField<ReportsFormValues>
        disabled={solarLandingSubmissionsMutation.isLoading}
        control={control}
        name="email"
        placeholder="Email"
      />

      <GradientButton
        disabled={solarLandingSubmissionsMutation.isLoading}
        type="submit"
        className={styles.button}
      >
        Get the Report
      </GradientButton>
    </form>
  );
};
